import * as React from 'react';
import {
  Dialog,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import {connect} from 'react-redux';
import {IFamilyMember} from '@app-types/websocket/family.types';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {FamilyMemberType} from "@services/family/family.constants";
import {INewEcoTransfer, IUpdateEcoTransfer, IEcoTransfer, EcoTransferMethod} from "@app-types/websocket/economy.types";
import DeleteIcon from '@material-ui/icons/DeleteForeverTwoTone';
import {
  BoxedRow,
  Col,
  CustomDialogContent,
  CustomSelectInverted,
  CustomTextFieldInverted,
  DialogTop,
  Row,
  StyledInputAdornment,
  StyledLabel,
} from './DialogComponens';
import ChatButton from './ChatButton';
import { ChatType } from '@app-types/websocket/chat.types';
import { addDays } from '@helpers/DateHelper';
import { buttonContainedLarge, styleColors } from 'src/main.style';

const tn = TranslateNew.getInstance();

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateNew: (values:INewEcoTransfer) => void;
  onEdit: (values:IUpdateEcoTransfer) => void;
  onDelete: (transferId:number) => void;
  onRestore: (transferId:number) => void;
  onChallenge: (transferId:number) => void;
  userId: number;
  family: IFamilyMember[];
  existingTransfer?: IEcoTransfer;
  method?:EcoTransferMethod;
  sum?:number;
  currency:string;
  waitForTransferChat:(id:number) => void;
}

interface IState {
  values: INewEcoTransfer;
  highlightSubtitle:boolean;
}

class TransferDialog extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    const {existingTransfer, method, sum} = this.props;

    this.state = {
      ...this.newState(existingTransfer, method, sum)
    };

  }

  public componentDidUpdate(oldProps:IProps) {
    if (this.props.isOpen === true && oldProps.isOpen === false) {
      const {existingTransfer, method, sum} = this.props;
      this.setState(this.newState(existingTransfer, method, sum));
    }
  }

  public newState(existingTransfer: IEcoTransfer|undefined, method: EcoTransferMethod|undefined, 
    sum:number|undefined ):IState {

    const coparentId = this.props.family.find((mem) =>(mem.role === FamilyMemberType.PARENT && mem.id !== this.props.userId));
    const to = coparentId !== undefined?coparentId.id:0; 
    if (existingTransfer) {
      return {
        highlightSubtitle:false,
        values: {
          from:existingTransfer.from, // 0 === shared
          to:existingTransfer.to, // 0 === shared
          sum:existingTransfer.sum,
          method:existingTransfer.method,
          note:existingTransfer.note,
          currency:existingTransfer.currency,
          booking:existingTransfer.booking,
        },
      };
    } else {

      const today = new Date();
      today.setHours(12);
      today.setMinutes(0);
      today.setSeconds(0);
      today.setMilliseconds(0);
      return {
        highlightSubtitle:false,
        values: {
          from:this.props.userId, // 0 === shared
          to, // 0 === shared
          sum:((sum !== undefined && sum>0)?sum:0),
          method:(method?method:EcoTransferMethod.BANK),
          note:"",
          currency:this.props.currency,
          booking:today.getTime(),
        },
      };
    }
  }

  public render() {
    const { isOpen, onClose,existingTransfer, family, currency, userId } = this.props;
    const { values } = this.state;

    let title = tn.lang.purchaseTransferNew;
    let subtitle:string|undefined;
    if (this.props.existingTransfer !== undefined && this.props.existingTransfer.deleted === true) {
      title = tn.lang.purchaseTransferDeleted;
    } else if (this.props.existingTransfer !== undefined) {
      title = this.props.existingTransfer.creator === userId?tn.lang.purchaseTransferEdit:tn.lang.purchaseTransferEditNotMine;
      subtitle =tn.lang.purchaseEditSubtitle(tn.familyMemberName(this.props.existingTransfer.creator, this.props.family));
    }
    let buttonText = tn.lang.save;
    if (this.props.existingTransfer !== undefined && this.props.existingTransfer.deleted === true) {
      buttonText = tn.lang.done;
    } else if (this.props.existingTransfer !== undefined) {
      buttonText = tn.lang.update;
    }

  let actionButton = <Button onClick={() => this.handleSubmit()} color='primary' variant='contained' style={buttonContainedLarge}
      disabled={(this.props.existingTransfer !== undefined && this.props.existingTransfer.deleted)}>
      
      {buttonText}
    
    </Button>;
    
  if (this.props.existingTransfer !== undefined 
    && !this.props.existingTransfer.deleted
    && this.props.existingTransfer.creator !== this.props.userId) {
    const tra = this.props.existingTransfer;
    actionButton = <Button color={(this.props.existingTransfer.disputedBy && this.props.existingTransfer.disputedBy > 0)?'primary':'secondary'}
      variant='contained' style={buttonContainedLarge} onClick={() => this.props.onChallenge(tra.id)}>
      {(this.props.existingTransfer.disputedBy && this.props.existingTransfer.disputedBy > 0)
        ?tn.lang.approve
        :tn.lang.question}
    </Button>;
  }

  // Like deleting, only the creator can restore a transfer.
  if (this.props.existingTransfer !== undefined 
    && this.props.existingTransfer.deleted
    && this.props.existingTransfer.creator === this.props.userId) {
    const tra = this.props.existingTransfer;
    actionButton = <Button color='primary' variant='contained' style={buttonContainedLarge}
      onClick={() => this.props.onRestore(tra.id)}>
      {tn.lang.ecoRestore}
    </Button>;
  }

  let chatButton:JSX.Element|undefined;
  if (existingTransfer !== undefined && (existingTransfer.chatId !== undefined || existingTransfer.creator !== this.props.userId)) {
    const chatTitle = tn.lang.transferRegardingTitle(tn.formatNumber(existingTransfer.sum, currency), 
      tn.formatMonthDate(new Date(existingTransfer.date)));
    chatButton = <ChatButton referenceObject={existingTransfer.id} family={family} chatId={existingTransfer.chatId} chatType={ChatType.TRANSFER_CHAT}
      title = {chatTitle} msg = {existingTransfer.note?existingTransfer.note:chatTitle} callBack={onClose} 
      waitForTransferChat={this.props.waitForTransferChat}/>;
  } 

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth={true}
      >
        <DialogTop>
          <Col style={{flex:1, alignItems: 'center'}}>
            <DialogTitle>{title}</DialogTitle>
            {subtitle && 
              <StyledLabel style={this.state.highlightSubtitle
                ?{marginTop: '-16px', color:styleColors.pureRed,fontWeight: 600, fontSize: '10px'}:{marginTop: '-16px'}}>
                {subtitle}
              </StyledLabel>}
          </Col>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <CustomDialogContent style={{position:'relative'}}>
        {(this.props.existingTransfer !== undefined && this.props.existingTransfer.creator !== this.props.userId) && 
          <div style={{position:'absolute', width:'100%', height:'100%', zIndex:2, top:0, left:0}} 
            onClick={() => this.setState({highlightSubtitle:true})} />}
          <BoxedRow style={{ flex: 1 }}>
            <StyledLabel htmlFor="from" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, gap:'8px', }}>
              <span>{tn.lang.from}:</span>
            </StyledLabel>
            <Col>
              <CustomSelectInverted
                name="from"
                value={(""+values.from)}
                onChange={this.handleChange}
                displayEmpty={true}
                disableUnderline={true}
                data={this.transferOptions()}
              />
            </Col>
          </BoxedRow>
          <BoxedRow style={{ flex: 1 }}>
            <StyledLabel htmlFor="to" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, gap:'8px', }}>
              <span>{tn.lang.to}:</span>
            </StyledLabel>
            <Col>
              <CustomSelectInverted
                name="to"
                value={(""+values.to)}
                onChange={this.handleChange}
                displayEmpty={true}
                disableUnderline={true}
                data={this.transferOptions()}
              />
            </Col>
          </BoxedRow>
          <BoxedRow>
            <Col style={{ flex: 1, alignItems: 'flex-start', justifyContent: 'center', minWidth: 110 }}>
              <StyledLabel htmlFor="amount">{tn.lang.sum}</StyledLabel>
            </Col>
            <Col>
              <CustomTextFieldInverted
                name="sum"
                value={values.sum===0?"":values.sum}
                placeholder={tn.lang.sum}
                onChange={this.handleChange}
                type="number" 
                inputMode="numeric"
                autoComplete="off"
                InputProps={{
                  disableUnderline: true,
                  endAdornment: (<StyledInputAdornment position="end" disableTypography={true}>{this.props.currency}</StyledInputAdornment>),
                }}
                InputLabelProps={{ shrink: false }}
              />
            </Col>
          </BoxedRow>
          <BoxedRow style={{ flex: 1 }}>
            <StyledLabel htmlFor="method" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, gap:'8px', }}>
              <span>{tn.lang.ecoTransferMethod}:</span>
            </StyledLabel>
            <Col>
              <CustomSelectInverted
                name="method"
                value={values.method}
                onChange={this.handleChange}
                displayEmpty={true}
                disableUnderline={true}
                data={Object.values(EcoTransferMethod).map((option) => ({value:(""+option), element:<>{tn.lang.transferOption(option)}</>}))}
              />
            </Col>
          </BoxedRow>
          <BoxedRow style={{ flex: 1 }}>
            <StyledLabel htmlFor="booking" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, gap:'8px', }}>
              <span>{tn.lang.ecoTransferBooking}</span>
            </StyledLabel>
            <Col>
              <CustomSelectInverted
                name="booking"
                value={(""+values.booking)}
                onChange={this.handleChange}
                displayEmpty={true}
                disableUnderline={true}
                data={this.bookingOptions()}
              />
            </Col>
          </BoxedRow>
          <BoxedRow>
            <Col style={{flex:1}}>
                <TextField
                  name="note"
                  style={{flex:1}}
                  value={values.note}
                  placeholder={tn.lang.labelMessage}
                  onChange={this.handleChange}
                  multiline={true}
                  InputProps={{ disableUnderline: true }}
                  InputLabelProps={{ shrink: false }}
                />
            </Col>
          </BoxedRow>
          
        </CustomDialogContent>
        <Row style={{justifyContent: 'space-between', alignItems: 'center', padding: '0px 24px 20px'}}>
          {chatButton}
          {(this.props.existingTransfer !== undefined && this.props.existingTransfer.creator === this.props.userId 
            && this.props.existingTransfer.deleted === false)
            && <IconButton onClick={() => this.handleDelete()}><DeleteIcon style={{fill:styleColors.coral800}} /></IconButton>}
          <Button style={buttonContainedLarge} onClick={onClose} color='default' variant='outlined' >
            {tn.lang.cancel}
          </Button>
          {actionButton}
        </Row>
      </Dialog>
    );
  }

  private bookingOptions = () => {

    const options: Array<{
      value: string;
      element: JSX.Element;
    }> = [];

    let spin = (this.props.existingTransfer)
      ?this.props.existingTransfer.booking
        ?new Date(this.props.existingTransfer.booking) 
        :new Date(this.props.existingTransfer.date) 
      :new Date();
    spin.setHours(12);
    spin.setMinutes(0);
    spin.setSeconds(0);
    spin.setMilliseconds(0);

    options.push({value:(""+spin.getTime()), element:<>
      {tn.lang.getMonthName(spin.getMonth()) + " "+spin.getFullYear()}</>});

    for (let index = 0; index < 3; index++) {
      const thisMonth = spin.getMonth();
      while (spin.getMonth() === thisMonth) {
        spin = addDays(spin,-1);
      }
      options.push({value:(""+spin.getTime()), element:<>{tn.lang.getMonthName(spin.getMonth())+ " "+spin.getFullYear()}</>});

    }

    return options;

  }

  private transferOptions = () => {
    const options = this.props.family.filter(mem => mem.role === FamilyMemberType.PARENT).map((mem) => 
      ({value:(""+mem.id), element:<>{mem.firstName}</>}));
    options.push({value:"0", element:<>{tn.lang.purchaseTransferAccountShared}</>});
    return options;

  }

  private handleDelete = () => {
    if (this.props.existingTransfer !== undefined) {
      this.props.onDelete(this.props.existingTransfer.id);
    }
  }

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;
    this.setState((prevState: any) => ({
      values: {
        ...prevState.values,
        [name]: newValue,
      },
    }));
  }

  
  private handleSubmit = () => {
    const { values } = this.state;
    if (this.props.existingTransfer && this.props.existingTransfer.id) {
      const update:IUpdateEcoTransfer = {
        id:this.props.existingTransfer.id,
        from:values.from, // 0 === shared
        to:values.to, // 0 === shared
        sum:values.sum,
        method:values.method,
        note:values.note,
        booking:values.booking,
        disputedBy:this.props.existingTransfer.disputedBy,
        chatId:this.props.existingTransfer.chatId,
      };
      this.props.onEdit(update);
    } else {
      this.props.onCreateNew(this.state.values);
    }
    
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family: state.family.family,
  };
}

export default connect(mapStateToProps)(TransferDialog);



// WEBPACK FOOTER //
// ./src/components/economy/TransferDialog.tsx